// ─────────────────────────────────────────────────────────────────────────────
// FEATURE: Favourites  (saved catches — API for pages/Favourites.tsx and the heart buttons)
// GET/PUT/DELETE /api/me/favourites → backend `customers/{uid}/favourites/{catchId}`. A favourite is a catch the signed-in
// customer saved, optionally with the cut and pack size they like it in; "Add to cart" on the Favourites page reuses both.
// (Separate from utils/favourites.ts, which is the device-local "favourite categories" chosen at onboarding.)
// ─────────────────────────────────────────────────────────────────────────────
import type { CutId } from "../data/cuts";
import type { PackId } from "../data/packs";
import { apiAuthed } from "./api";

export interface FavouriteCatch {
  catchId: string;
  cut: CutId | null;
  pack: PackId | null;
  createdAt: string;
}

export const fetchFavouriteCatches = () => apiAuthed<FavouriteCatch[]>("GET", "/me/favourites");

export const saveFavouriteCatch = (catchId: string, choice: { cut?: CutId | null; pack?: PackId | null } = {}) =>
  apiAuthed<FavouriteCatch>("PUT", `/me/favourites/${catchId}`, { cut: choice.cut ?? null, pack: choice.pack ?? null });

export const removeFavouriteCatch = (catchId: string) => apiAuthed<{ deleted: boolean }>("DELETE", `/me/favourites/${catchId}`);
